import { ConfigColor } from "./config-color";
import { ColorGenerator } from "../utils/color-generator";
import { Traducible } from "./traducible";

export class ValorAtributo {
    idValorAtributo: number;
	idAtributo: number;
	idVersion: number;
    nombreDes: Traducible;
    peso: number;
    orden: number;
    nombreDesInfo: Traducible;
	codigo: string;
	abreviatura: string;
    color: ConfigColor = new ConfigColor();

    colorGenerator: ColorGenerator = new ColorGenerator();

    constructor(params=null) {
		if(params != null)
		{
			this.idValorAtributo = params.idValorAtributo;
			this.nombreDes = params.nombreDes;
			this.color = this.colorGenerator.generarColorHexAleatorio();
			this.idAtributo = params.idAtributo;
			this.peso = params.peso;
			this.codigo = params.codigo;
			this.nombreDesInfo = params.nombreDesInfo;
			this.orden = params.orden;
			this.abreviatura = params.abreviatura;
		}
	}
    
}